import styled from 'styled-components'
import { G } from '@/components/gold/theme'

/**
 * ver2(gold) 로그인 폼 — gold8.bet 실측
 *   PC(.loginDialog): 입력칸 340×50, 바탕 #0f1923, 글자 #a8a17f, 테두리 없음, 아래 간격 24.
 *     버튼 340×46, 노란 그라디언트(#ffef77→#fff0a7), 글자 #0f1923 굵게 16, 모서리 5.
 *   모바일(/Login): 입력칸 위 금색 라벨, 입력칸 바탕 #2f323a 모서리 10 높이 50, 버튼 노란 알약.
 */
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: ${({ $mobile }) => ($mobile ? '100%' : '340px')};
  max-width: 100%;
  .error { margin: -16px 0 14px; }
`

export const Label = styled.label`
  margin-bottom: 8px;
  text-align: center;
  font-size: 17px;
  font-weight: 700;
  color: #d29a12;
`

export const Field = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  ${({ $error }) => ($error ? 'outline: 1px solid #cd0030;' : '')}
  border-radius: ${({ $mobile }) => ($mobile ? '10px' : '0')};
`

export const Input = styled.input`
  && {
    width: 100%;
    height: 50px;
    padding: ${({ $mobile }) => ($mobile ? '0 48px 0 24px' : '0 40px 0 20px')};
    border: 0;
    border-radius: ${({ $mobile }) => ($mobile ? '10px' : '0')};
    background: ${({ $mobile }) => ($mobile ? '#2f323a' : G.bg)};
    font-size: ${({ $mobile }) => ($mobile ? '16px' : '13px')};
    color: ${({ $mobile }) => ($mobile ? '#fff' : G.sand)};
    outline: none;
    box-shadow: none;
  }
  &&::placeholder { color: ${({ $mobile }) => ($mobile ? '#8b8e95' : G.sand)}; }
`

export const EyeToggle = styled.span`
  position: absolute;
  right: ${({ $mobile }) => ($mobile ? '18px' : '13px')};
  display: flex;
  width: ${({ $mobile }) => ($mobile ? '26px' : '16px')};
  height: ${({ $mobile }) => ($mobile ? '26px' : '16px')};
  color: ${({ $mobile }) => ($mobile ? '#fff' : G.sand)};
  cursor: pointer;
`

export const IconSvg = styled.svg.attrs({ focusable: 'false' })`
  width: 100%;
  height: 100%;
  fill: currentColor;
  color: inherit;
`

export const LoginBtn = styled.button.attrs({ type: 'submit' })`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  border: 0;
  font-weight: 700;
  cursor: pointer;
  ${({ $mobile }) => ($mobile
    ? `height: 54px;
       margin-top: 14px;
       border-radius: 27px;
       background: linear-gradient(180deg, #fff1b0, #ffe04a);
       font-size: 22px;
       color: #000;`
    : `height: 46px;
       border-radius: 5px;
       background: linear-gradient(to right, #ffef77, #fff0a7);
       font-size: 16px;
       color: ${G.bg};`)}
  &:disabled { opacity: 0.7; cursor: default; }
`

export const Arrow = styled.span`
  font-size: 18px;
  color: inherit;
`

/** 「パスワードを忘れる」 — gold: 왼쪽 30px 들여쓰기, #a8a17f */
export const Forget = styled.button`
  align-self: flex-start;
  margin: 0 0 24px 20px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 14px;
  color: ${G.sand};
  cursor: pointer;
`

/** 「Don't have an account yet? Create one now!」 */
export const SignUpLine = styled.div`
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  button {
    margin-left: 10px;
    padding: 0;
    border: 0;
    background: none;
    font-size: 14px;
    font-weight: 700;
    color: ${G.gold};
    cursor: pointer;
  }
`
